import { useEffect, useState } from "react";
import Button from "../../../Custom/Button/Button";
import procenaRizikaImg from "../../../../picture/procena-rizika.png";
import evidencijeObrasciImg from "../../../../picture/evidencije-obrasci.png";
import poslovneJediniceImg from "../../../../picture/poslovne-jedinice.png";
import sredstvaOpremaImg from "../../../../picture/sredstva-oprema.png";
import dokumentaZaposlenihImg from "../../../../picture/dokumenta-zaposlenih.png";
import zastitaOdPozaraImg from "../../../../picture/zastita-od-pozara.png";
import zastitaZivSredineImg from "../../../../picture/zastita-ziv-sredine.png";
import poslovniSaradniciImg from "../../../../picture/poslovni-saradnici.png";
import ugovoriOdlukeImg from "../../../../picture/ugovori-odluke.png";
import SredstvaForm from "./SredstvaForm";
import { useGlobalContext } from "../../../../Context/Context";
import ProcenaRizikaForm from "./ProcenaRizikaForm";
import DokumentaZaposlenih from "./dokumenta-zaposlenih/GeneralDataForm";

const kategorije = [
  {
    key: "PROCENA_RIZIKA",
    naziv: "PROCENA RIZIKA",
    image: procenaRizikaImg,
  },
  {
    key: "EVIDENCIJE_OBRASCI",
    naziv: "EVIDENCIJE I OBRASCI",
    image: evidencijeObrasciImg,
  },
  {
    key: "POSLOVNE_JEDINICE",
    naziv: "POSLOVNE JEDINICE",
    image: poslovneJediniceImg,
  },
  {
    key: "SREDSTVA_OPREMA",
    naziv: "SREDSTVA I OPREMA",
    image: sredstvaOpremaImg,
  },
  {
    key: "DOKUMENTA_ZAPOSLENIH",
    naziv: "DOKUMENTA ZAPOSLENIH",
    image: dokumentaZaposlenihImg,
  },
  {
    key: "ZASTITA_OD_POZARA",
    naziv: "ZASTITA OD POZARA",
    image: zastitaOdPozaraImg,
  },
  {
    key: "ZASTITA_ZIV_SREDINE",
    naziv: "ZASTITA ZIV. SREDINE",
    image: zastitaZivSredineImg,
  },
  {
    key: "POSLOVNI_SARADNICI",
    naziv: "POSLOVNI SARADNICI",
    image: poslovniSaradniciImg,
  },
  {
    key: "UGOVORI_ODLUKE",
    naziv: "UGOVORI I ODLUKE",
    image: ugovoriOdlukeImg,
  },
];

function GlobalnoDodavanjeDokumenta({
  fileNewDocument,
  setCurrentTab,
  resetFile,
  openFilePicker,
  onClose 
}) {
  const [selectedCategory, setSelectedCategory] = useState("");

  const { selectedNavbarDocument } = useGlobalContext();

  useEffect(() => {
    setSelectedCategory(selectedNavbarDocument);
  }, [selectedNavbarDocument]);

  const mapping = {
    SREDSTVA_OPREMA: (
      <SredstvaForm
        fileNewDocument={fileNewDocument}
        setCurrentTab={setCurrentTab}
      />
    ),
    PROCENA_RIZIKA: <ProcenaRizikaForm fileNewDocument={fileNewDocument} />,
    DOKUMENTA_ZAPOSLENIH: (
      <DokumentaZaposlenih
        fileNewDocument={fileNewDocument}
        resetFile={resetFile}
        openFilePicker={openFilePicker}
        onClose={onClose}
      />
    ),
  };

  const handleSelectKategorija = (key) => {
    setSelectedCategory((prev) => (prev === key ? "" : key));
  };

  return (
    <div
      style={{
        padding: "20px",
        fontSize: "12px",
        overflow: "auto",
        height: "100%",
        width: "100%",
        backgroundColor: "#F9F9F9",
      }}
    >
      <div style={{ display: "flex" }}>
        {kategorije.map((kategorija) => (
          <div
            key={kategorija.key}
            onClick={() => handleSelectKategorija(kategorija.key)}
            className="div-documents-navbar"
          >
            <Button
              active={selectedCategory === kategorija.key}
              activation={true}
            >
              <div>
                <img src={kategorija.image} style={{ padding: "10px" }} />
                <br />
                <div style={{ fontWeight: "bold" }}>{kategorija.naziv}</div>
              </div>
            </Button>
          </div>
        ))}
      </div>

      {mapping[selectedCategory]}
    </div>
  );
}

export default GlobalnoDodavanjeDokumenta;
